import React from 'react'
import { Box, Stack, StackDivider } from '@chakra-ui/react'

const Stats = ({ page }, props) => {
  return (
    <Stack
      spacing={6}
      direction={['column', 'column', 'row']}
      divider={<StackDivider />}
    >
      {page.stats.map(({ ...stats }) => (
        <Stack
          key={stats.id}
          direction="column-reverse"
          mx="auto"
          as="dl"
          textAlign="center"
          {...props}
        >
          <Box as="dt">{stats.text}</Box>
          <Box
            as="dd"
            fontSize="5xl"
            fontWeight="bold"
            fontFamily="heading"
            mb={0}
          >
            {stats.number}
          </Box>
        </Stack>
      ))}
    </Stack>
  )
}

export default Stats
